import { useQuery } from 'react-query';
import { useLocale } from '../../../../../../i18n';
import { wgApi } from '../../../../../app/src/features/api/wgApi';
import { InsuranceProductsResp } from '../../../../../settings/src/features/risk-domains/types/InsuranceProducts';

export type PartyInsuranceProductsCategory = 'staff' | 'management';

export interface UseGetInsuranceProductsProps {
  partyId?: string;
  category?: PartyInsuranceProductsCategory;
  q?: string;
  recommendationId?: string;
}

export const getUseInsuranceProductsByPartyQKey = (
  partyId?: string,
  category?: string,
  q?: string,
  recommendationId?: string,
) => ['insurance-products', partyId, category, q, recommendationId];

const getInsuranceProductsByParty = async ({
  userCountry,
  userLang,
  partyId,
  category,
  q,
  recommendationId,
}: UseGetInsuranceProductsProps & {
  userCountry: string;
  userLang: string;
}): Promise<InsuranceProductsResp> => {
  const url = category
    ? `v1/api/parties/${partyId}/${category}/possible-insurance-products`
    : `v1/api/parties/${partyId}/possible-insurance-products`;
  const { data, isError } = await wgApi.get<InsuranceProductsResp>(url, {
    query: {
      country: userCountry,
      lang: userLang,
      pagelen: 999,
      q,
      recommendation_id: recommendationId,
    },
  });
  if (isError) throw new Error();
  return data;
};

export const useInsuranceProductsByParty = ({
  partyId,
  category,
  q,
  recommendationId,
}: UseGetInsuranceProductsProps) => {
  const { userCountry, userLang } = useLocale();

  return useQuery(
    getUseInsuranceProductsByPartyQKey(partyId, category, q, recommendationId),
    () =>
      getInsuranceProductsByParty({
        userCountry,
        userLang,
        partyId,
        category,
        q,
        recommendationId,
      }),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      enabled: !!partyId,
    },
  );
};
